import { RootState } from 'duck/store'

import { ACCOUNT_PAGE_STORE_ID } from './types'

export const getAccountPageState = (state: RootState) => state.scenes[ACCOUNT_PAGE_STORE_ID]
